import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import NodePartnerTeaser from './Teaser';
import NodePartnerPage from './Page';
import { NodePartner } from '../../../types/uncinc_profile/nodes';

interface NodePartnerProps {
  entity: ImmutableEntity<NodePartner>;
  viewMode: string;
}

const NodePartnerWrapper: React.FC<NodePartnerProps> = ({ entity, viewMode }) => {
  switch (viewMode) {
    case 'teaser':
      return <NodePartnerTeaser entity={entity} />;
    default:
      return <NodePartnerPage entity={entity} />;
  }
};

export default NodePartnerWrapper;
